import Icon from '@ant-design/icons';
import { openNewTab } from 'util/helpers';
import { SIDE_MENU_EVENTS } from './sideMenu';
import type { MenuProps } from 'antd';
import { EDITOR_MENU_LOGOS_URL } from 'util/constants';
import { REDIRECT_TO_STUDIO_EDITOR } from 'pages/user/studio/scene/[id]';
type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  disabled?: boolean,
  children?: MenuItem[],
  onClick?: VoidFunction
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    disabled,
    onClick,
  } as MenuItem;
}

const ZEPETO_WEB_DOCS =
  'https://docs.ozonemetaverse.io/zepeto/import_scene_unity';
const ZEPETO_DOCS =
  'https://docs.zepeto.me/studio/reference/installation_and_settings';

const menuDefault = ({
  callBack,
  setMenuSelected,
  tourRefs,
  styles,
  openAssetStore,
  openMyStuff,
  isAddedInitialPoint,
  addInitialPoint,
  isAdmin,
  setIsOpenWeb2AssetStore,
  setIsOpenMyInventory,
  setIsOpenFreeAssets,
  setIsOpenMyScenes,
  setIsOpenWorlds,
  isSignIn,
  onOpenAddToSceneModal,
}) => [
  getItem(
    <div ref={tourRefs[9]}>My projects</div>,
    'MY-SCENES',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}my-projects-icon.svg`}
          alt='my scenes'
        />
      )}
    />,
    !isSignIn,
    undefined,
    () => {
      setMenuSelected(['MY-SCENES']);
      setIsOpenMyScenes(true);
    }
  ),
  /* getItem(
      <div ref={tourRefs[2]}>Prefabs</div>,
      'Prefabs',
      <Icon
        component={() => (
          <img
            src={`${EDITOR_MENU_LOGOS_URL}listings-icon.svg`}
            alt='extra assets'
          />
        )}
      />,
      false,
      [
        getItem(
          'Worlds',
          'worlds',
          false,
          false,
          undefined,
          () => {
            setMenuSelected(['worlds']);
            setMenuSelected(['3D LIBRARY']);
            callBack(SIDE_MENU_EVENTS.SCENES);
          }
        ),
        getItem(
          '3D library',
          '3D LIBRARY',
          false,
          false,
          undefined,
          () => {
            setMenuSelected(['3D LIBRARY']);
            callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
          }
        ),
      ]
    ), */
  getItem(
    <span ref={tourRefs[6]}>Add to scene</span>,
    'add-to-scene',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}add-to-scene-icon.svg`}
          alt='add-to-scene'
        />
      )}
    />,
    false,
    undefined,
    () => {
      if (typeof onOpenAddToSceneModal === 'function') onOpenAddToSceneModal();
      setMenuSelected(['add-to-scene']);
    }
  ),
  getItem(
    <span ref={tourRefs[8]}>Lighting</span>,
    'LIGHTS-4',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}lightning-icon.svg`} alt='lights' />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['LIGHTS-4']);
      callBack(SIDE_MENU_EVENTS.LIGHTS);
    }
  ),
  getItem(
    <span ref={tourRefs[10]}>Custom Code</span>,
    'CUSTOM-CODE',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}code-circle.svg`} alt='Logo' />
      )}
    />,
    false,
    undefined,
    () => {
      window.dispatchEvent(new CustomEvent(REDIRECT_TO_STUDIO_EDITOR));
    }
  ),
  getItem(
    <span ref={tourRefs[11]}>Sky</span>,
    'SKY-3',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}sky-icon.svg`} alt='sky' />
      )}
    />,
    false,
    [
      getItem('Presets', 'sky-presets', false, false, undefined, () => {
        setMenuSelected(['sky-presets']);
        callBack(SIDE_MENU_EVENTS.SKY);
      }),
      getItem(
        <div>
          AI <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'generate-sky-with-ai',
        false,
        true,
        undefined,
        () => {
          setMenuSelected(['generate-sky-with-ai']);
          // callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[12]}>E-commerce</span>,
    'e-commerce',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}add-to-scene-icon.svg`}
          alt='add-to-scene'
        />
      )}
    />,
    false,
    [
      getItem(
        'My listings',
        'CREATED-ASSETS-6',
        process.env.NEXT_PUBLIC_CREATED_ASSETS !== 'true',
        false,
        undefined,
        () => {
          setMenuSelected(['CREATED-ASSETS-6']);
          callBack(SIDE_MENU_EVENTS.CREATED_ASSETS);
        }
      ),
      getItem(
        <div>
          Shopify <div className={styles.expBadge}>Experimental</div>
        </div>,
        'shopify',
        false,
        process.env.NEXT_PUBLIC_SHOPIFY !== 'true',
        undefined,
        () => {
          setMenuSelected(['shopify']);
          callBack(SIDE_MENU_EVENTS.SHOPIFY);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[13]}>Web3</span>,
    'my-assets',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}web-3-icon.svg`} alt='nft assets' />
      )}
    />,
    false,
    [
      getItem('Web3 assets', 'NFT-ASSETS-5', false, false, undefined, () => {
        setMenuSelected(['NFT-ASSETS-5']);
        callBack(SIDE_MENU_EVENTS.NFT_ASSETS);
      }),
      getItem(
        'Land assets',
        'LAND-ASSETS-12',
        false,
        process.env.NEXT_PUBLIC_MENU_LAND_ASSETS !== 'true',
        undefined,
        () => {
          setMenuSelected(['LAND-ASSETS-12']);
          callBack(SIDE_MENU_EVENTS.LAND_ASSETS);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[14]}>OZONE AI Mind</span>,
    'ai-services',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}ai-services-icon.svg`}
          alt='ai services'
        />
      )}
    />,
    false,
    [
      getItem(
        <div>
          Agent 3D <div className={styles.expBadge}>Experimental</div>
        </div>,
        'AI_avatars',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['AI_avatars']);
          callBack(SIDE_MENU_EVENTS.AI_AVATARS);
        }
      ),
      getItem(
        <div>
          Chat GPT <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'chat-gpt',
        false,
        process.env.NEXT_PUBLIC_CHAT_GPT !== 'false',
        undefined,
        () => {
          setMenuSelected(['chat-gpt']);
          // callBack(SIDE_MENU_EVENTS.CHAT_GPT);
        }
      ),
      getItem(
        <div>
          Custom Characters<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'custom-characters',
        false,
        process.env.NEXT_PUBLIC_CUSTOM_CHARACTERS !== 'false',
        undefined,
        () => {
          setMenuSelected(['custom-characters']);
          // callBack(SIDE_MENU_EVENTS.CUSTOM_CHARACTERS);
        }
      ),
      getItem(
        <div>
          Stable diffusion <div className={styles.soonBadge}>Coming soon</div>{' '}
        </div>,
        'stable-diffusion',
        false,
        process.env.NEXT_PUBLIC_STABLE_DIFFUSION !== 'false',
        undefined,
        () => {
          setMenuSelected(['stable-diffusion']);
          // callBack(SIDE_MENU_EVENTS.STABLE_DIFFUSION);
        }
      ),
      getItem(
        <div>
          Leonardo AI<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'leonardo-ai',
        false,
        process.env.NEXT_PUBLIC_LEONARDO_AI !== 'false',
        undefined,
        () => {
          setMenuSelected(['leonardo-ai']);
          // callBack(SIDE_MENU_EVENTS.LEONARDO_AI);
        }
      ),
      getItem(
        <div>
          Video AI<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'video-ai',
        false,
        process.env.NEXT_PUBLIC_VIDEO_AI !== 'false',
        undefined,
        () => {
          setMenuSelected(['video-ai']);
          // callBack(SIDE_MENU_EVENTS.VIDEO_AI);
        }
      ),
      getItem(
        <div>
          Ozone AI Mind<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'ozone-ai-mind',
        false,
        process.env.NEXT_PUBLIC_OZONE_AI_MIND !== 'false',
        undefined,
        () => {
          setMenuSelected(['ozone-ai-mind']);
          // callBack(SIDE_MENU_EVENTS.OZONE_AI_MIND);
        }
      ),
      getItem(
        <div>
          3D Gen AI <div className={styles.expBadge}>Experimental</div>
        </div>,
        'three-d-generation',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['three-d-generation']);
          callBack(SIDE_MENU_EVENTS.THREE_D_GENERATION);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[15]}>Game hub</span>,
    'games',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}game-hub-icon.svg`} alt='games' />
      )}
    />,
    false,
    [
      getItem(
        <div>
          Quests <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'quests',
        false,
        process.env.NEXT_PUBLIC_QUESTS !== 'true',
        undefined,
        () => {
          setMenuSelected(['quests']);
          callBack(SIDE_MENU_EVENTS.QUESTS);
        }
      ),
      getItem(
        <div>
          Hide and Seek <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'hide-and-seek',
        false,
        process.env.NEXT_PUBLIC_HIDE_AND_SEEK !== 'true',
        undefined,
        () => {
          setMenuSelected(['hide-and-seek']);
          callBack(SIDE_MENU_EVENTS.HIDE_AND_SEEK);
        }
      ),
      getItem(
        <div>
          RPG <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'rpg-game',
        false,
        process.env.NEXT_PUBLIC_RPG_GAME !== 'true',
        undefined,
        () => {
          setMenuSelected(['rpg-game']);
          callBack(SIDE_MENU_EVENTS.RPG_GAME);
        }
      ),
      getItem(
        <div>
          Running game<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'running-game',
        false,
        process.env.NEXT_PUBLIC_RUNNING_GAME !== 'true',
        undefined,
        () => {
          setMenuSelected(['running-game']);
          callBack(SIDE_MENU_EVENTS.RUNNING_GAME);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[16]}>Networking</span>,
    'NETWORKING',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}networking-icon.svg`}
          alt='networking'
        />
      )}
    />,
    false,
    [
      getItem(
        'Enable text chat',
        'enable-text-chat',
        false,
        false,
        undefined,
        () => {
          setMenuSelected(['enable-text-chat']);
          callBack(SIDE_MENU_EVENTS.TEXT_CHAT);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[17]}>Graphics settings</span>,
    'graphics-settings',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}graphics-settings-icon.svg`}
          alt='Graphics settings'
        />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['graphics-settings']);
      callBack(SIDE_MENU_EVENTS.GRAPHICS_SETTINGS);
    }
  ),
  getItem(
    'Admin',
    'admin',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}admin-icon.svg`} alt='Add stream' />
      )}
    />,
    !isAdmin,
    [
      getItem(
        <div>MFE Worlds</div>,
        'mfe_worlds',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['mfe_worlds']);
          callBack(SIDE_MENU_EVENTS.MFE_WORLDS);
        }
      ),
      getItem(
        <div>
          Scan Scene <div className={styles.expBadge}>Experimental</div>
        </div>,
        'scan_scene',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['scan_scene']);
          callBack(SIDE_MENU_EVENTS.SCAN_SCENE);
        }
      ),
      getItem(
        <div>
          BIM model scanner <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'bim-model-scanner',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['bim-model-scanner']);
          callBack(SIDE_MENU_EVENTS.BIM_MODEL_SCANNER);
        }
      ),
      getItem('Tour', 'tour', false, !isAdmin, undefined, () => {
        setMenuSelected(['tour']);
        callBack(SIDE_MENU_EVENTS.TOUR);
      }),
      getItem(
        'Scene Configuration',
        'scene_config',
        false,
        !isAdmin,
        undefined,
        () => {
          setMenuSelected(['scene_config']);
          callBack(SIDE_MENU_EVENTS.SCENE_CONFIG);
        }
      ),
      getItem(
        'Scene Hierarchy',
        'SCENE-OBJECTS-0',
        false,
        isAdmin,
        undefined,
        () => {
          setMenuSelected(['SCENE-OBJECTS-0']);
          callBack(SIDE_MENU_EVENTS.OBJECTS_IN_SCENE);
        }
      ),
    ]
  ),
];

const menuUnity = ({
  callBack,
  setMenuSelected,
  tourRefs,
  styles,
  openAssetStore,
  openMyStuff,
  isAddedInitialPoint,
  addInitialPoint,
  isAdmin,
  setIsOpenMyScenes,
  isSignIn,
  setIsOpenMyInventory,
  setIsOpenFreeAssets,
  setIsOpenWeb2AssetStore,
  setIsOpenWorlds,
}) => [
  getItem(
    <div ref={tourRefs[5]}>My projects</div>,
    'MY-SCENES',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}my-projects-icon.svg`}
          alt='my scenes'
        />
      )}
    />,
    !isSignIn,
    undefined,
    () => {
      setMenuSelected(['MY-SCENES']);
      setIsOpenMyScenes(true);
    }
  ),
  getItem(
    <div ref={tourRefs[7]}>Asset store</div>,
    'ASSET-STORE-6',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}asset-store-icon.svg`}
          alt='asset store'
        />
      )}
    />,
    false,
    [
      getItem(
        <div>My Inventory</div>,
        'ASSET-STORE-INVENTORY',
        false,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-INVENTORY']);
          setIsOpenMyInventory(true);
        }
      ),
      getItem(<div>Free Assets</div>, 'ASSET-STORE-ASSETS-21', false, false, [
        getItem(
          <div>Assets</div>,
          'ASSET-STORE-ASSETS-21-CHILD',
          false,
          false,
          undefined,
          () => {
            setMenuSelected(['ASSET-STORE-ASSETS-21']);
            setIsOpenFreeAssets(true);
          }
        ),
        getItem('Worlds and Prefabs', 'worlds', false, false, undefined, () => {
          setMenuSelected(['worlds']);
          callBack(SIDE_MENU_EVENTS.SCENES);
        }),
        getItem('3D library', '3D LIBRARY', false, false, undefined, () => {
          setMenuSelected(['3D LIBRARY']);
          callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
        }),
      ]),
      getItem(
        <div>Paid Assets</div>,
        'ASSET-STORE-10',
        false,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-10']);
          setIsOpenWeb2AssetStore(true);
        }
      ),
    ],
    undefined
  ),
  /* getItem(
      <div ref={tourRefs[2]}>Prefabs</div>,
      'Prefabs',
      <Icon
        component={() => (
          <img
            src={`${EDITOR_MENU_LOGOS_URL}listings-icon.svg`}
            alt='extra assets'
          />
        )}
      />,
      false,
      [
        getItem(
          'Worlds',
          'worlds',
          false,
          false,
          undefined,
          () => {
            setMenuSelected(['worlds']);
            setMenuSelected(['3D LIBRARY']);
            callBack(SIDE_MENU_EVENTS.SCENES);
          }
        ),
        getItem(
          '3D library',
          '3D LIBRARY',
          false,
          false,
          undefined,
          () => {
            setMenuSelected(['3D LIBRARY']);
            callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
          }
        ),
      ]
    ), */
  getItem(
    'Upload asset',
    'Upload-asset-7',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}upload-new-assets.svg`}
          alt='lights'
        />
      )}
    />,
    process.env.NEXT_PUBLIC_MENU_MY_STUFF !== 'true',
    undefined,
    () => {
      setMenuSelected(['Upload-asset-7']);
      openMyStuff();
    }
  ),
  getItem(
    <span ref={tourRefs[8]}>Lighting</span>,
    'LIGHTS-4',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}lightning-icon.svg`} alt='lights' />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['LIGHTS-4']);
      callBack(SIDE_MENU_EVENTS.LIGHTS);
    }
  ),
  getItem(
    <span ref={tourRefs[11]}>Sky</span>,
    'SKY-3',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}sky-icon.svg`} alt='sky' />
      )}
    />,
    false,
    [
      getItem('Presets', 'sky-presets', false, false, undefined, () => {
        setMenuSelected(['sky-presets']);
        callBack(SIDE_MENU_EVENTS.SKY);
      }),
      getItem(
        <div>
          AI <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'generate-sky-with-ai',
        false,
        true,
        undefined,
        () => {
          setMenuSelected(['generate-sky-with-ai']);
          // callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
        }
      ),
    ]
  ),
];

const menuXsolla = ({
  callBack,
  setMenuSelected,
  tourRefs,
  styles,
  openAssetStore,
  openMyStuff,
  isAddedInitialPoint,
  addInitialPoint,
  isAdmin,
  setIsOpenWeb2AssetStore,
  setIsOpenMyInventory,
  setIsOpenFreeAssets,
  setIsOpenMyScenes,
  setIsOpenWorlds,
  isSignIn,
  onOpenAddToSceneModal,
}) => [
  getItem(
    <div ref={tourRefs[9]}>My projects</div>,
    'MY-SCENES',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}my-projects-icon.svg`}
          alt='my scenes'
        />
      )}
    />,
    !isSignIn,
    undefined,
    () => {
      setMenuSelected(['MY-SCENES']);
      setIsOpenMyScenes(true);
    }
  ),
  getItem(
    <span ref={tourRefs[6]}>Add to scene</span>,
    'add-to-scene',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}add-to-scene-icon.svg`}
          alt='add-to-scene'
        />
      )}
    />,
    false,
    undefined,
    () => {
      if (typeof onOpenAddToSceneModal === 'function') onOpenAddToSceneModal();
      setMenuSelected(['add-to-scene']);
    }
  ),
  getItem(
    <span ref={tourRefs[8]}>Lighting</span>,
    'LIGHTS-4',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}lightning-icon.svg`} alt='lights' />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['LIGHTS-4']);
      callBack(SIDE_MENU_EVENTS.LIGHTS);
    }
  ),
  getItem(
    <span ref={tourRefs[10]}>Custom Code</span>,
    'CUSTOM-CODE',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}code-circle.svg`} alt='Logo' />
      )}
    />,
    false,
    undefined,
    () => {
      window.dispatchEvent(new CustomEvent(REDIRECT_TO_STUDIO_EDITOR));
    }
  ),
  getItem(
    <span ref={tourRefs[11]}>Sky</span>,
    'SKY-3',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}sky-icon.svg`} alt='sky' />
      )}
    />,
    false,
    [
      getItem('Presets', 'sky-presets', false, false, undefined, () => {
        setMenuSelected(['sky-presets']);
        callBack(SIDE_MENU_EVENTS.SKY);
      }),
      getItem(
        <div>
          AI <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'generate-sky-with-ai',
        false,
        true,
        undefined,
        () => {
          setMenuSelected(['generate-sky-with-ai']);
          // callBack(SIDE_MENU_EVENTS.LIBRARY_3D);
        }
      ),
    ]
  ),
  /*   getItem(
    <span ref={tourRefs[14]}>3D Gen AI</span>,
    'three-d-generation',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}ai-services-icon.svg`}
          alt='ai services'
        />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['three-d-generation']);
      callBack(SIDE_MENU_EVENTS.THREE_D_GENERATION);
    }
  ), */
  getItem(
    <span ref={tourRefs[15]}>Game hub</span>,
    'games',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}game-hub-icon.svg`} alt='games' />
      )}
    />,
    false,
    [
      getItem(
        <div>Quests</div>,
        'quests',
        false,
        process.env.NEXT_PUBLIC_QUESTS !== 'true',
        undefined,
        () => {
          setMenuSelected(['quests']);
          callBack(SIDE_MENU_EVENTS.QUESTS);
        }
      ),
      getItem(
        <div>Hide and Seek</div>,
        'hide-and-seek',
        false,
        process.env.NEXT_PUBLIC_HIDE_AND_SEEK !== 'true',
        undefined,
        () => {
          setMenuSelected(['hide-and-seek']);
          callBack(SIDE_MENU_EVENTS.HIDE_AND_SEEK);
        }
      ),
      getItem(
        <div>
          RPG <div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'rpg-game',
        false,
        process.env.NEXT_PUBLIC_RPG_GAME !== 'true',
        undefined,
        () => {
          setMenuSelected(['rpg-game']);
          callBack(SIDE_MENU_EVENTS.RPG_GAME);
        }
      ),
      getItem(
        <div>
          Running game<div className={styles.soonBadge}>Coming soon</div>
        </div>,
        'running-game',
        false,
        process.env.NEXT_PUBLIC_RUNNING_GAME !== 'true',
        undefined,
        () => {
          setMenuSelected(['running-game']);
          callBack(SIDE_MENU_EVENTS.RUNNING_GAME);
        }
      ),
    ]
  ),
  getItem(
    <span ref={tourRefs[16]}>Enable text chat</span>,
    'enable-text-chat',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}networking-icon.svg`}
          alt='networking'
        />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['enable-text-chat']);
      callBack(SIDE_MENU_EVENTS.TEXT_CHAT);
    }
  ),
  getItem(
    <span ref={tourRefs[17]}>Graphics settings</span>,
    'graphics-settings',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}graphics-settings-icon.svg`}
          alt='Graphics settings'
        />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['graphics-settings']);
      callBack(SIDE_MENU_EVENTS.GRAPHICS_SETTINGS);
    }
  ),
];

const menuZepeto = ({
  callBack,
  setMenuSelected,
  tourRefs,
  styles,
  setZepetoKey,
  openAssetStore,
  setZepetoInstructionsVisible,
  setIsTourOpen,
  setIsOpenWeb2AssetStore,
  setIsOpenMyInventory,
  isAdmin,
  setIsOpenFreeAssets,
  setIsOpenMyScenes,
  isSignIn,
  setIsOpenNewPaidCollection,
}) => [
  getItem(
    <div ref={tourRefs[6]}>Quick Presets</div>,
    'enviroments',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}listings-icon.svg`}
          alt='enviroments'
        />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['worlds']);
      callBack(SIDE_MENU_EVENTS.SCENES);
    }
  ),
  getItem(
    <span ref={tourRefs[8]}>Lighting</span>,
    'LIGHTS-4',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}lightning-icon.svg`} alt='lights' />
      )}
    />,
    false,
    undefined,
    () => {
      setMenuSelected(['LIGHTS-4']);
      callBack(SIDE_MENU_EVENTS.LIGHTS);
    }
  ),
  getItem(
    <div ref={tourRefs[9]}>My Scenes</div>,
    'MY-SCENES',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}objects-scene-icon.svg`}
          alt='my scenes'
        />
      )}
    />,
    !isSignIn,
    undefined,
    () => {
      setMenuSelected(['MY-SCENES']);
      setIsOpenMyScenes(true);
    }
  ),
  getItem(
    <div ref={tourRefs[7]}>Asset store</div>,
    'ASSET-STORE-6',
    <Icon
      component={() => (
        <img
          src={`${EDITOR_MENU_LOGOS_URL}asset-store-icon.svg`}
          alt='asset store'
        />
      )}
    />,
    false,
    [
      getItem(
        <div>My Inventory</div>,
        'ASSET-STORE-INVENTORY',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}library-3d-icon.svg`}
              alt='my inventory'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-INVENTORY']);
          setIsOpenMyInventory(true);
        }
      ),
      getItem(
        <div>Free Assets</div>,
        'ASSET-STORE-11',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}asset-store-icon.svg`}
              alt='asset store'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-11']);
          setIsOpenFreeAssets(true);
        }
      ),
      getItem(
        <div>Paid Assets</div>,
        'ASSET-STORE-10',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}asset-store-icon.svg`}
              alt='asset store'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-10']);
          setIsOpenWeb2AssetStore(true);
        }
      ),
      getItem(
        <div>New Collection</div>,
        'ASSET-STORE-12',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}asset-store-icon.svg`}
              alt='asset store'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setMenuSelected(['ASSET-STORE-12']);
          setIsOpenNewPaidCollection(true);
        }
      ),
    ],
    undefined
  ),
  getItem(
    <span ref={tourRefs[10]}>Documentation</span>,
    'resources',
    <Icon
      component={() => (
        <img src={`${EDITOR_MENU_LOGOS_URL}docs-icon.svg`} alt='resources' />
      )}
    />,
    false,
    [
      getItem(
        'World Export',
        'setup-unity-package',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}unity-icon.svg`}
              alt='Setup Zepeto Web Unity'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setZepetoInstructionsVisible(true);
        }
      ),
      getItem(
        'Tutorial',
        'tutorial',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}zepeto-icon.svg`}
              width={20}
              height={20}
              alt='tutorial'
            />
          )}
        />,
        false,
        undefined,
        () => {
          openNewTab(ZEPETO_WEB_DOCS);
        }
      ),
      getItem(
        'Zepeto Docs',
        'zepeto-docs',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}info-icon.svg`}
              width={20}
              height={20}
              alt='Zepeto Docs'
            />
          )}
        />,
        false,
        undefined,
        () => {
          openNewTab(ZEPETO_DOCS);
        }
      ),
      getItem(
        'Zepeto Studio Tour',
        'zepeto-studio-tour',
        <Icon
          component={() => (
            <img
              src={`${EDITOR_MENU_LOGOS_URL}tour-icon.svg`}
              width={20}
              height={20}
              alt='Zepeto Studio Guided Tour'
            />
          )}
        />,
        false,
        undefined,
        () => {
          setIsTourOpen(true);
        }
      ),
    ]
  ),
];

export default function menuItems({
  branding,
  callBack,
  setMenuSelected,
  tourRefs,
  styles,
  openAssetStore,
  openMyStuff,
  isAddedInitialPoint,
  addInitialPoint,
  setZepetoKey,
  setZepetoInstructionsVisible,
  setIsTourOpen,
  isAdmin,
  setIsOpenWeb2AssetStore,
  setIsOpenMyInventory,
  setIsOpenFreeAssets,
  setIsOpenMyScenes,
  setIsOpenWorlds,
  isSignIn,
  setIsOpenNewPaidCollection,
  onOpenAddToSceneModal,
}) {
  const isZepeto = branding === 'ZEPETO';
  const isXsolla = branding === 'XSOLLA';
  const isUnity = branding === 'UNITY';

  if (isZepeto) {
    return menuZepeto({
      callBack,
      setMenuSelected,
      tourRefs,
      styles,
      setZepetoKey,
      openAssetStore,
      setZepetoInstructionsVisible,
      setIsTourOpen,
      setIsOpenWeb2AssetStore,
      setIsOpenMyInventory,
      isAdmin,
      setIsOpenFreeAssets,
      setIsOpenMyScenes,
      isSignIn,
      setIsOpenNewPaidCollection,
    });
  }

  if (isXsolla) {
    return menuXsolla({
      callBack,
      setMenuSelected,
      tourRefs,
      styles,
      openAssetStore,
      openMyStuff,
      isAddedInitialPoint,
      addInitialPoint,
      isAdmin,
      setIsOpenWeb2AssetStore,
      setIsOpenMyInventory,
      setIsOpenFreeAssets,
      setIsOpenMyScenes,
      setIsOpenWorlds,
      isSignIn,
      onOpenAddToSceneModal,
    });
  }

  if (isUnity) {
    return menuUnity({
      callBack,
      setMenuSelected,
      tourRefs,
      styles,
      openAssetStore,
      openMyStuff,
      isAddedInitialPoint,
      addInitialPoint,
      isAdmin,
      setIsOpenMyScenes,
      isSignIn,
      setIsOpenMyInventory,
      setIsOpenFreeAssets,
      setIsOpenWeb2AssetStore,
      setIsOpenWorlds,
    });
  }

  return menuDefault({
    callBack,
    setMenuSelected,
    tourRefs,
    styles,
    openAssetStore,
    openMyStuff,
    isAddedInitialPoint,
    addInitialPoint,
    isAdmin,
    setIsOpenMyScenes,
    isSignIn,
    setIsOpenMyInventory,
    setIsOpenFreeAssets,
    setIsOpenWeb2AssetStore,
    setIsOpenWorlds,
    onOpenAddToSceneModal,
  });
}
